import { storageKeys } from '@/app/constants/storageKeys';
import { httpClient } from '@/app/libs';
import { createPanel } from '@/app/services/panelsService/createPanel';
import { getPanel } from '@/app/services/panelsService/getPanel';
import { logoutPanel } from '@/app/services/panelsService/logoutPanel';
import { storage } from '@/app/storage';

const deletePanelItem = ({ nomeItemPainel, tipoItemPainel }) =>
  httpClient.delete(`/paineis/itens/${nomeItemPainel}/tipos/${tipoItemPainel}`);

const getUserPanelItems = ({ idPrograma, idRoteiro }) =>
  httpClient.get('/usuario/paineis/itens', { params: { idPrograma, idRoteiro } });

const postPanelGroup = ({ codigoDispositivo, nomeGrupo }) =>
  httpClient.post(
    '/paineis',
    { codigoDispositivo, nomeGrupo },
    {
      safeErrorStatus: [401],
    },
  );

const putPanelCode = ({ codigoPainel, idPrograma, idRoteiro }) =>
  httpClient.put(`/programas/${idPrograma}/roteiros/${idRoteiro}/paineis/${codigoPainel}`, {
    data: {
      accessToken: storage.get(storageKeys.ACCESS_TOKEN),
      idToken: storage.get(storageKeys.ACCESS_TOKEN),
      refreshToken: storage.get(storageKeys.REFRESH_TOKEN),
    },
    method: 'PUT',
    path: `/programas/${idPrograma}/roteiros/${idRoteiro}/paineis/${codigoPainel}`,
  });

export const panelsService = {
  putPanelCode,
  postPanelGroup,
  logoutPanel,
  getUserPanelItems,
  getPanel,
  createPanel,
  deletePanelItem,
};
